module.exports = {
  path: 'confirm-email',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/ConfirmEmail').default || require('./components/ConfirmEmail'));
    }, 'confirmemail');
  }
};



// WEBPACK FOOTER //
// ./routes/confirmEmail/index.js